const React = require('react');
const ReactIntl = require('react-intl');

const { Text, Input, Button, Modal, ModalContent, ModalHeader, IconButton } = require('@metro-ui/core');
const { Back } = require('@metro-ui/icons');

const defaultMessages = require('../../i18n/messages/default');
const LoginStore = require('../../stores/LoginStore');
const LoginActions = require('../../actions/LoginActions');

const { injectIntl } = ReactIntl;

class SecurityDeviceModal extends React.Component {
  constructor() {
    super();
    this.state = {
      deviceName: '',
      userWebauthnDevices: [],
      webauthnSupported : typeof(PublicKeyCredential) !== "undefined"
    }

    this.onWebauthnCredentials = this.onWebauthnCredentials.bind(this);
    this.save2faWebAuthnListener = this.save2faWebAuthnListener.bind(this);
    this.onUserCredentialsCreated = this.onUserCredentialsCreated.bind(this);
    this.createCredentials = this.createCredentials.bind(this);
    this.onInputChange = this.onInputChange.bind(this);
  }

  componentDidMount() {
    LoginStore.Save2FAWebAuthnListener(this.save2faWebAuthnListener);
    LoginStore.userCredentialsCreatedListener(this.onUserCredentialsCreated);
    LoginStore.webauthnCredentialsListener(this.onWebauthnCredentials);
    LoginActions.get2faWebAuthnCredentials(this.props.idToken, this.props.decodedIdToken.sub, this.props.traceId);
  }

  componentWillUnmount() {
    LoginStore.removeSave2FAWebAuthnListener(this.save2faWebAuthnListener);
    LoginStore.removeUserCredentialsCreatedListener(this.onUserCredentialsCreated);
    LoginStore.removeWebauthnCredentialsListener(this.onWebauthnCredentials);
  }

  onWebauthnCredentials() {
    const appState = LoginStore.getState();
    if (appState.fetchWebauthnFailure) {
      LoginActions.triggerToast(
        this.props.intl.formatMessage(defaultMessages['loginpreferences.2famethods.webauthn.get_keys_failure_msg']),
        "error",
        true
      );
      this.setState({ userWebauthnDevices: [] });
    } else {
      this.setState({ userWebauthnDevices: appState.userWebauthnDevices });
    }
  }

  save2faWebAuthnListener() {
    const appState = LoginStore.getState();
    if (appState.updateAuthnMethodError){
      LoginActions.triggerToast(
        this.props.intl.formatMessage(defaultMessages['loginpreferences.2famethods.webauthn.msg_setup_failed']),
        "error",
        true
      );
    } else {
      LoginActions.getUserMFAMethods(this.props.idToken, this.props.countryCode); // refresh the 2FA list
      this.props.onNavItemClick(2, true); //pass true to GetUserDetails
      LoginActions.triggerToast(
        this.props.intl.formatMessage(defaultMessages['loginpreferences.2famethods.webauthn.msg_setup_successful']),
        "success",
        true
      );
      this.props.closeModal();
    }

  }

  onUserCredentialsCreated(){
    const appState = LoginStore.getState();
    LoginStore.save2faCred(
      this.props.idToken,
      appState.userCredentialsCreated,
      this.props.decodedIdToken.sub,
      this.state.deviceName,
      this.props.userType,
      this.props.traceId,
      this.props.authMethod,
      {
        domain: `${window.location.protocol}//${window.location.host}`,
      },
      true
    );
  }

  createCredentials(){  
    const appState = LoginStore.getState();
    LoginActions.createWebauthnCredentials(
      this.props.idToken,
      appState.challenge,
      this.props.decodedIdToken.sub,
      this.props.email,
      this.props.traceId
    );
}

  onInputChange(_, deviceName) {
    this.setState({ deviceName });
  }

  render() {
    const { intl, closeModal, onBackNavigationClick } = this.props;
    const { deviceName, userWebauthnDevices, webauthnSupported } = this.state;
    const isSubmitDisabled = deviceName.trim().length === 0 ||
      userWebauthnDevices.filter(
        eachDevice => eachDevice.deviceName.toUpperCase() === deviceName.trim().toUpperCase()
      ).length !== 0;
    return (
      <Modal
        style={{
          'width': '27vw'
        }}
        aria-labelledby="modal-title"
        isOpen
        onDismiss={closeModal}
      >
        <ModalHeader
          align="end"
          isClosable
          padding="medium"
          spacing="medium"
        >
          <IconButton
            Icon={Back}
            hasNoInteractionEffect
            label="Back"
            color="metro-blue"
            onClick={onBackNavigationClick}
          />
          {intl.formatMessage(defaultMessages['loginpreferences.2famethods.webauthn.security_device'])}
        </ModalHeader>
        <ModalContent
          direction="column"
          padding="xx-large"
          spacing="medium"
        >
          <Text className="margin-bottom-small" size="medium">
            <strong>{intl.formatMessage(defaultMessages['loginpreferences.2famethods.webauthn.step_0'])}</strong>
          </Text>
          <Text className="margin-bottom-small" size="medium">
            {intl.formatMessage(defaultMessages['loginpreferences.2famethods.webauthn.step_1'])}</Text>
          <div className="two-fa-form-controls">
            <Input
              placeholder={intl.formatMessage(defaultMessages['loginpreferences.2famethods.webauthn.device_name_hint'])}
              value={deviceName}
              onChange={this.onInputChange}
              triggerInputPulseAnimation
              isRequired />
          </div>
          <Text className="margin-bottom-small" hasNoNativeMargin>
            {intl.formatMessage(defaultMessages['loginpreferences.2famethods.webauthn.step_2'])}
          </Text>
          <Text className="margin-bottom-small" size="medium">
            {intl.formatMessage(defaultMessages['loginpreferences.2famethods.webauthn.step_3'])}
          </Text>
          {!webauthnSupported && (
            <Text className= "margin-bottom-small" size= "small" color="warning">
              *{intl.formatMessage(defaultMessages['loginpreferences.2famethods.webauthn.browswer_not_supported'])}
            </Text>
          )}
          <div className="two-fa-form-controls">
            <Button size='medium'
              isWide
              variant='primary'
              isDisabled={isSubmitDisabled}
              onClick={this.createCredentials}
            >
              {intl.formatMessage(defaultMessages['loginpreferences.2famethods.webauthn.register_device'])}
            </Button>
          </div>
        </ModalContent>
      </Modal>
    );
  }
};

module.exports = injectIntl(SecurityDeviceModal);
